import React from 'react';
import { connect } from 'react-redux';
import {
    createSelectProviderAction,
    createDisplayProviderDialogAction,
    createCloseProviderDialogAction,
    createAndPerformStartAuthenticationAction
} from 'common/actions/authenticationActions';
import injectIntl, { intlShape } from 'common/injectIntl';
import { shallowCheckAuthentication } from 'lib/auth';
import { authenticationEnabled as authenticationEnabledSelector } from 'selectors/authenticationSelectors';
import ProviderDialog from './ProviderDialog';

class AuthenticationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.providerSelect = this.providerSelect.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillReceiveProps({ authentication: nextAuthentication, authenticationEnabled, selectedContent: nextContent }) {
        const currentAuthentication = this.props.authentication;

        const currentAdobePass = currentAuthentication.adobePass || {};
        const nextAdobePass = nextAuthentication.adobePass || {};
        const currentCheckAuthentication = currentAdobePass.checkAuthentication || {};
        const nextCheckAuthentication = nextAdobePass.checkAuthentication || {};

        const checkAuthenticationStateChanged = currentCheckAuthentication.completeTime
            !== nextCheckAuthentication.completeTime;

        const contentSelected = this.props.selectedContent !== nextContent;

        // if check authentication completes and a piece of content was already selected,
        // or if check authentication has completed already and user clicked on content, perform authentication
        if (authenticationEnabled === true && nextContent.disableAuthPrompt !== true &&
            ((nextContent && nextContent.type === 'event' &&
                shallowCheckAuthentication(nextContent, nextAuthentication.authTypes) === false) &&
                    ((checkAuthenticationStateChanged && nextContent) ||
                        (contentSelected && nextCheckAuthentication.completeTime)))) {
            // the second param is autoplay, third param is launchPlayer (passes launchPlayer=true or nothing)
            this.props.dispatch(createAndPerformStartAuthenticationAction(nextContent))
                .then((isAuthenticated) => {
                    if (isAuthenticated === false) {
                        this.props.dispatch(createDisplayProviderDialogAction());
                    }
                });
        }
    }

    providerSelect(provider) {
        this.props.dispatch(createSelectProviderAction(provider));
    }

    closeModal() {
        this.props.dispatch(createCloseProviderDialogAction());
        this.props.dispatch(createSelectProviderAction({ ID: null }));
    }

    render() {
        const { messages, intl: { formatMessage } } = this.props;
        const { providers = [], display = false } = this.props.providerDialog;
        // FIXME: Supposed to use `FormattedMessage` from `react-intl` but can't use it because of css `>span`
        const description = formatMessage(messages['provider.dialog.description'], {
            noCost: `
                <span>
                    ${formatMessage(messages['provider.dialog.description.noCost'])}
                </span>
            `,
            link: `
                <a href="${formatMessage(messages['provider.dialog.faq.link'])}" class="watchProvider__link">
                    ${formatMessage(messages['provider.dialog.faq.label'])}
                </a>
            `,
            call: formatMessage(messages['provider.dialog.call'])
        });
        return (
            <ProviderDialog
                providers={providers}
                showProviderDialog={display}
                providerSelect={this.providerSelect}
                closeModal={this.closeModal}
                title={formatMessage(messages['provider.dialog.title'])}
                description={description}
                tier1Subtitle={formatMessage(messages['provider.dialog.subtitle.tier1'])}
                subtitle={formatMessage(messages['provider.dialog.subtitle'])}
                placeholder={formatMessage(messages['search.filter.placeholder'])}
            />
        );
    }
}

AuthenticationContainer.propTypes = {
    dispatch: React.PropTypes.func,
    authenticationEnabled: React.PropTypes.bool,
    authentication: React.PropTypes.object,
    providerDialog: React.PropTypes.object,
    selectedContent: React.PropTypes.object,
    intl: intlShape.isRequired,
    messages: React.PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    const { authentication = {}, providerDialog } = state;

    return {
        authentication,
        authenticationEnabled: authenticationEnabledSelector(state),
        selectedContent: state.app.selectedContent,
        providerDialog
    };
};

export default connect(mapStateToProps)(injectIntl(AuthenticationContainer));



// WEBPACK FOOTER //
// ./app/modal/authn/AuthenticationContainer.js